export default "__VITE_PUBLIC_ASSET__ee3ea148__"